type SectionBannerProps = { src: string; alt?: string };

const SectionBanner = ({ src, alt = "فاصل بصري من هوية جمعية الصداقة الفلسطينية الصينية" }: SectionBannerProps) => (
  <div className="relative h-[100px] md:h-[140px] lg:h-[180px] w-full overflow-hidden bg-black">
    {/* @section: section-banner */}
    <img src={src} alt={alt} className="h-full w-full object-cover" loading="lazy" />
    <div className="absolute inset-0 bg-gradient-to-l from-chinese-red/15 via-transparent to-pal-green/20" />
  </div>
);

export default SectionBanner;
